import { getOtherQueryParameters, getPathFromSelectedChoices, getProtocolWithHost } from '../utils/pathUtils';
import { UPDATE_PATH } from './actionTypes';

export const updatePath = () => (dispatch, getState) => {
  const {
    configurator,
    config: { isCanonicalUrlSelfReferenced },
    uploadImages,
    designContent: {
      viewAccessories,
    }
  } = getState();

  const otherQueryParams = getOtherQueryParameters();
  const url = getPathFromSelectedChoices(configurator, uploadImages, viewAccessories) + otherQueryParams;

  if (url && url?.length > 0 && typeof url === 'string') {
    window.history.replaceState('updated path', document.title, url);
  }

  if (isCanonicalUrlSelfReferenced) {
    dispatch({
      type: UPDATE_PATH,
      url: `${getProtocolWithHost()}${url}`,
    });
  }
};
